import { addClass, createDom, removeClass } from 'xgplayer/src/utils/util'
import '../style/controls/pip.scss'
import PipIcon from '../assets/pip.svg'
import PipInnerIcon from '../assets/pip-inner.svg'

let s_pip = function() {
  let player = this
  let root = player.root

  if (!player.config.pip) {
    return
  }

  const pip = player.lang.PIP

  const btn = createDom(
    'xg-pip',
    `<xg-icon class="xgplayer-icon">${PipIcon}</xg-icon>`,
    { tabindex: 9 },
    'xgplayer-pip'
  )

  const tips = createDom(
    'xg-tips',
    `${pip}
    `,
    {},
    'xgplayer-tips tips-with-corn'
  )

  const pipInner = createDom(
    'xg-pip-inner',
    `${PipInnerIcon}<div class="xgplayer-pip-inner-text">以“画中画” 模式播放</div>`,
    {},
    'xgplayer-pip-inner'
  )

  const showPipInner = () => {
    addClass(pipInner, 'xgplayer-pip-inner-active')
  }

  const hidePipInner = () => {
    removeClass(pipInner, 'xgplayer-pip-inner-active')
  }

  btn.appendChild(tips)

  root.appendChild(pipInner)

  player.video.addEventListener('enterpictureinpicture', showPipInner)
  player.video.addEventListener('leavepictureinpicture', hidePipInner)

  player.once('ready', () => {
    player.controls.appendChild(btn)
  })
  ;['click', 'touchend'].forEach(item => {
    btn.addEventListener(item, e => {
      e.preventDefault()
      e.stopPropagation()
      player.userGestureTrigEvent('pipBtnClick')
    })
  })
}

export default {
  name: 's_pip',
  method: s_pip
}
